import {
  IoAccessibilityOutline,
  IoAdd,
  IoAddCircle,
  IoAlertCircleOutline,
  IoApps,
  IoAppsOutline,
  IoArrowBack,
  IoArrowDownOutline,
  IoArrowForward,
  IoArrowRedoOutline,
  IoBagOutline,
  IoBookmarkOutline,
  IoBookmarksOutline,
  IoBookOutline,
  IoBulbOutline,
  IoBusinessOutline,
  IoCalculatorOutline,
  IoCalendarClearOutline,
  IoCalendarOutline,
  IoCallOutline,
  IoCardOutline,
  IoCaretUp,
  IoCarOutline,
  IoCartOutline,
  IoCashOutline,
  IoChatbubbleEllipsesOutline,
  IoChatbubbleOutline,
  IoCheckmark,
  IoChevronBack,
  IoChevronBackCircleOutline,
  IoChevronDown,
  IoChevronForward,
  IoChevronUp,
  IoClipboardOutline,
  IoClose,
  IoCloudOutline,
  IoCodeSlashOutline,
  IoCogOutline,
  IoConstructOutline,
  IoCubeOutline,
  IoDesktopOutline,
  IoDiamondOutline,
  IoDocumentAttachOutline,
  IoDocumentLockOutline,
  IoDocumentTextOutline,
  IoEarthOutline,
  IoEaselOutline,
  IoEyeOffOutline,
  IoEyeOutline,
  IoFilmOutline,
  IoFilterOutline,
  IoFlagOutline,
  IoFlashOutline,
  IoFlaskOutline,
  IoFootstepsOutline,
  IoFunnelOutline,
  IoGitBranchOutline,
  IoGlobeOutline,
  IoGridOutline,
  IoHeart,
  IoHeartOutline,
  IoHelpBuoyOutline,
  IoHelpCircleOutline,
  IoHelpOutline,
  IoHomeOutline,
  IoImageOutline,
  IoInfiniteOutline,
  IoKeyOutline,
  IoKeypadOutline,
  IoLaptopOutline,
  IoLayersOutline,
  IoLeafOutline,
  IoLinkOutline,
  IoLocationOutline,
  IoLockClosedOutline,
  IoLogoFacebook,
  IoLogoTwitter,
  IoMail,
  IoMailOpenOutline,
  IoMailOutline,
  IoMapOutline,
  IoMedkitOutline,
  IoMegaphoneOutline,
  IoMegaphoneSharp,
  IoNavigateOutline,
  IoNewspaperOutline,
  IoNotificationsOutline,
  IoOptionsOutline,
  IoPaperPlaneOutline,
  IoPencilOutline,
  IoPeopleOutline,
  IoPerson,
  IoPersonCircleOutline,
  IoPhonePortraitOutline,
  IoPricetagOutline,
  IoPulseOutline,
  IoReaderOutline,
  IoRefreshOutline,
  IoRepeatOutline,
  IoRocketOutline,
  IoRocketSharp,
  IoScanOutline,
  IoSchoolOutline,
  IoSearch,
  IoSearchOutline,
  IoServerOutline,
  IoSettingsOutline,
  IoShareSocialOutline,
  IoShieldCheckmark,
  IoShieldCheckmarkOutline,
  IoShieldHalfOutline,
  IoSparklesOutline,
  IoSpeedometerOutline,
  IoStarOutline,
  IoStatsChartOutline,
  IoStopwatchOutline,
  IoStorefrontOutline,
  IoSwapHorizontalOutline,
  IoTerminalOutline,
  IoTimeOutline,
  IoTimerOutline,
  IoTrashOutline,
  IoTrendingDownOutline,
  IoTrendingUpOutline,
  IoTrophyOutline,
  IoUnlinkOutline,
  IoWalletOutline,
  IoWarningOutline,
  IoWaterOutline
} from "react-icons/io5"

const ionIcons = Object.freeze({
  IoAccessibilityOutline,
  IoAdd,
  IoAddCircle,
  IoAlertCircleOutline,
  IoApps,
  IoAppsOutline,
  IoArrowBack,
  IoArrowDownOutline,
  IoArrowForward,
  IoArrowRedoOutline,
  IoBagOutline,
  IoBookOutline,
  IoBookmarkOutline,
  IoBookmarksOutline,
  IoBulbOutline,
  IoCalculatorOutline,
  IoCallOutline,
  IoBusinessOutline,
  IoCalendarClearOutline,
  IoCalendarOutline,
  IoCarOutline,
  IoCardOutline,
  IoCaretUp,
  IoCartOutline,
  IoCashOutline,
  IoChatbubbleEllipsesOutline,
  IoChatbubbleOutline,
  IoCheckmark,
  IoChevronBack,
  IoChevronBackCircleOutline,
  IoChevronDown,
  IoChevronForward,
  IoChevronUp,
  IoClipboardOutline,
  IoClose,
  IoCloudOutline,
  IoCodeSlashOutline,
  IoCogOutline,
  IoConstructOutline,
  IoCubeOutline,
  IoDesktopOutline,
  IoDiamondOutline,
  IoDocumentAttachOutline,
  IoDocumentLockOutline,
  IoDocumentTextOutline,
  IoEarthOutline,
  IoEaselOutline,
  IoEyeOffOutline,
  IoEyeOutline,
  IoFilmOutline,
  IoFilterOutline,
  IoFlagOutline,
  IoFlashOutline,
  IoFlaskOutline,
  IoFootstepsOutline,
  IoFunnelOutline,
  IoGitBranchOutline,
  IoGlobeOutline,
  IoGridOutline,
  IoHeart,
  IoHeartOutline,
  IoHelpBuoyOutline,
  IoHelpCircleOutline,
  IoHelpOutline,
  IoHomeOutline,
  IoImageOutline,
  IoInfiniteOutline,
  IoKeyOutline,
  IoKeypadOutline,
  IoLaptopOutline,
  IoLayersOutline,
  IoLeafOutline,
  IoLinkOutline,
  IoLocationOutline,
  IoLockClosedOutline,
  IoLogoFacebook,
  IoLogoTwitter,
  IoMail,
  IoMailOpenOutline,
  IoMailOutline,
  IoMapOutline,
  IoMedkitOutline,
  IoMegaphoneOutline,
  IoMegaphoneSharp,
  IoNavigateOutline,
  IoNewspaperOutline,
  IoNotificationsOutline,
  IoOptionsOutline,
  IoPaperPlaneOutline,
  IoPencilOutline,
  IoPeopleOutline,
  IoPerson,
  IoPersonCircleOutline,
  IoPhonePortraitOutline,
  IoPricetagOutline,
  IoPulseOutline,
  IoReaderOutline,
  IoRefreshOutline,
  IoRepeatOutline,
  IoRocketOutline,
  IoRocketSharp,
  IoScanOutline,
  IoSchoolOutline,
  IoSearch,
  IoSearchOutline,
  IoServerOutline,
  IoSettingsOutline,
  IoShareSocialOutline,
  IoShieldCheckmark,
  IoShieldCheckmarkOutline,
  IoShieldHalfOutline,
  IoSparklesOutline,
  IoSpeedometerOutline,
  IoStarOutline,
  IoStatsChartOutline,
  IoStopwatchOutline,
  IoStorefrontOutline,
  IoSwapHorizontalOutline,
  IoTerminalOutline,
  IoTimeOutline,
  IoTimerOutline,
  IoTrashOutline,
  IoTrendingDownOutline,
  IoTrendingUpOutline,
  IoTrophyOutline,
  IoUnlinkOutline,
  IoWalletOutline,
  IoWaterOutline,
  IoWarningOutline
})

export default ionIcons
